import React from 'react'
import { useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import CustomTable from '../../components/Shared/CustomTable'
import PageHeader from '../../components/Shared/PageHeader'

export default function ViewDeductionPage () {
  const location = useLocation()
  const { t } = useTranslation()
  const deduction = location?.state?.deduction || null

  const columns = [
    {
      header: t('name'),
      body: row => `${row.employee?.first_name || ''} ${row.employee?.last_name || ''}`
    },
    { field: 'deduction_type', header: t('deduction_type') },
    { field: 'amount', header: t('amount') },
    { field: 'effective_date', header: t('effective_date') },
    { field: 'description', header: t('description') }
  ]

  if (!deduction) {
    return (
      <div>
        <PageHeader title={t('Deduction Details')} />
        <p className='mt-4'>{t('No_deduction_selected')}</p>
        <div className='mt-4'></div>
      </div>
    )
  }

  const data = [deduction]

  return (
    <div>
      <PageHeader title={t('Deduction Details')} />
      <CustomTable data={data} columns={columns} rows={1} />
    </div>
  )
}
